import { ContactDetailPage } from "@/features/contact/pages/ContactDetail";
import React, { FC } from "react";

type TContactDetailProps = {
  isCompany: boolean;
};

const ContactDetail: FC<TContactDetailProps> = ({ isCompany }) => {
  return <ContactDetailPage isCompany={isCompany} />;
};

export default ContactDetail;
